import { FleetsStoreState } from "./FleetsStore.types";

export const fleetsStoreState: FleetsStoreState = {
  fleets: [],
};
